import type { ReactNode } from 'react';
import type { IssueTypeKey } from '@/lib/metric-view/aggregation';

/**
 * Shared layout primitives for Metric View's right-rail summary cards.
 * Extracted so ThroughputSummaryCard and WipSummaryCard don't duplicate
 * identical column and label structures.
 */

export function SummaryColumn({
  title,
  subtitle,
  children,
}: Readonly<{ title: string; subtitle: string; children: ReactNode }>) {
  return (
    <div>
      <div className="mb-2 text-center">
        <div className="text-sm font-semibold text-foreground">{title}</div>
        <div className="text-[11px] text-muted-foreground">{subtitle}</div>
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

export function issueTypeLabel(type: IssueTypeKey): string {
  if (type === 'Story') return 'Stories';
  if (type === 'Bug') return 'Bugs';
  return 'Tasks';
}
